import classNames from "classnames";
import { useAppContext } from "providers/AppProvider";
import { Navbar } from "react-bootstrap";
import logo from "assets/img/icons/logo-withoutbg.png";
import { useBreakpoints } from "providers/BreakpointsProvider";
import NavbarToggleButton from "./NavbarToggleButton";
import { Link } from "react-router-dom";

const getEnvironmentLabel = () => {
  const host =
    typeof window !== "undefined" ? window.location.hostname : "";
  if (host.includes("stage") || host.includes("test")) return "Staging";
  if (host.includes("localhost") || host.startsWith("127.")) return "Local";
  return "Production";
};

const NavbarBrand = () => {
  const {
    config: { navbarTopShape, navbarPosition },
  } = useAppContext();
  const { breakpoints } = useBreakpoints();
  const environmentLabel = getEnvironmentLabel();

  return (
    <>
      <div className="navbar-logo">
        {breakpoints.down("lg") && <NavbarToggleButton />}
        <Navbar.Brand
          as={Link}
          to="/"
          className={classNames({
            "me-1 me-sm-3":
              navbarTopShape === "slim" || navbarPosition === "horizontal",
          })}
        >
          {navbarTopShape === "slim" ? (
            <>
              phoenix{" "}
              <span className="text-body-highlight d-none d-sm-inline">
                slim
              </span>
            </>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <img src={logo} alt="AddressBox Admin" width={180} />
            </div>
          )}
        </Navbar.Brand>
      </div>
    </>
  );
};

export default NavbarBrand;
